/**
 * Displays the Duration filter section.
 *
 * @param {*} props Contains 'filters' state variable & 'setFilters' state method.
 */
export default function DurationFilter(props) {
  const durationStartFilter = props.filters.duration.start;
  const durationEndFilter = props.filters.duration.end;
  const setDurationFilter = props.setFilters;

  // Saves the state of the start duration filter when a new date is picked.
  const handleStartDateChange = (e) => {
    props.setParam("startDate", e.target.value);
    setDurationFilter((prevState) => ({
      ...prevState,
      duration: { ...prevState.duration, start: e.target.value },
    }));
  };

  // Saves the state of the end duration filter when a new date is picked.
  const handleEndDateChange = (e) => {
    props.setParam("endDate", e.target.value);
    setDurationFilter((prevState) => ({
      ...prevState,
      duration: { ...prevState.duration, end: e.target.value },
    }));
  };

  return (
    <>
      <div className="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:pt-1" >
        <label htmlFor="startDate"
          className="block text-sm font-base text-gray-500 sm:mt-px sm:pt-2 dark:text-gray-400" >
          Start After:
        </label>
        <div className="mt-1 sm:mt-0 sm:col-span-2" >
          <div className="max-w-lg flex rounded-md shadow-sm" >
            <input 
              type="date"
              name="startDate"
              id="startDate"
              data-cy="start-date"
              // Saves the "state" of the filter when opening and closing the Disclosure window.
              value={[...durationStartFilter].filter((filterOption) => filterOption == durationStartFilter) == "" ? durationStartFilter : ""}
              onChange={handleStartDateChange}
              max={durationEndFilter}
              className="flex-1 block w-full p-2 border focus:ring-blue-700 focus:border-blue-700 min-w-0 rounded-md sm:text-sm border-gray-300 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:placeholder-gray-400 dark:[color-scheme:dark]" 
            />
          </div>
        </div>
        <label htmlFor="endDate"
          className="block text-sm font-base text-gray-500 sm:mt-px sm:pt-2 mt-4 dark:text-gray-400" >
          End Before:
        </label>
        <div className="mt-1 sm:mt-0 sm:col-span-2" >
          <div className="max-w-lg flex rounded-md shadow-sm" >
            <input 
              type="date"
              name="endDate"
              id="endDate"
              data-cy="end-date"
              // Saves the "state" of the filter when opening and closing the Disclosure window.
              value={[...durationEndFilter].filter((filterOption) => filterOption == durationEndFilter) == "" ? durationEndFilter : ""}
              onChange={handleEndDateChange}
              min={durationStartFilter}
              className="flex-1 block w-full p-2 border focus:ring-blue-700 focus:border-blue-700 min-w-0 rounded-md sm:text-sm border-gray-300 dark:bg-gray-700 dark:border-gray-600 dark:text-white dark:placeholder-gray-400 dark:[color-scheme:dark]" 
            />
          </div>
        </div>
      </div>
    </>
  );
}